import Store from 'src/store';
export default function getCurrentMode() {
    return Store.state.mode.currentMode;
}
